<template>
	<span :class="cn(badgeVariants({ variant }), props.class)" v-bind="$attrs">
		<slot />
	</span>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';
import { badgeVariants, type BadgeVariants } from './badgeVariants';

const props = withDefaults(
	defineProps<{
		variant?: BadgeVariants['variant'];
		class?: string;
	}>(),
	{
		variant: 'default',
	},
);
</script>
